import { render, staticRenderFns } from "./addpaymentParameterSwitching.vue?vue&type=template&id=77afaed0&scoped=true&"
import script from "./addpaymentParameterSwitching.vue?vue&type=script&lang=js&"
export * from "./addpaymentParameterSwitching.vue?vue&type=script&lang=js&"
import style0 from "./addpaymentParameterSwitching.vue?vue&type=style&index=0&id=77afaed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afaed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77afaed0')) {
      api.createRecord('77afaed0', component.options)
    } else {
      api.reload('77afaed0', component.options)
    }
    module.hot.accept("./addpaymentParameterSwitching.vue?vue&type=template&id=77afaed0&scoped=true&", function () {
      api.rerender('77afaed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addpaymentParameterSwitching.vue"
export default component.exports